module.exports = __webpack_public_path__ + "img/payments-razorpay-stripe.302a683b.png";